var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"IframeOrdini","tag":"section"}},[_c('iFrame',{attrs:{"width":"100%","height":"800px","src":"","name":"myIframe"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }